import { createAsyncThunk } from '@reduxjs/toolkit';

import { TransactionsService } from 'api';

import { FilterDateParams } from 'models';

export const downloadTransactions = createAsyncThunk(
	'statement/downloadTransactions',
	async (data: { params: FilterDateParams }) => {
		const result = await TransactionsService.download(data);
		const file = new Blob([result as unknown as BlobPart]);
		const fileURL = URL.createObjectURL(file);
		const link = document.createElement('a');
		link.download = `transactions.xlsx`;
		link.href = fileURL;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},
);
